import styled from 'styled-components'
import Pagination from 'react-bootstrap/Pagination'
import styles from '../../utility/styles'
import Post from './Post'
import Text from '../shared/Text'
import Button from '../shared/Button'
import RetryButton from '../shared/RetryButton'

const Wrapper = styled.div``

const ErrorWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`

const StyledPagination = styled(Pagination)`
	display: flex;
	justify-content: center;
`

const StyledPaginationItem = styled(Pagination.Item)`
	background-color: ${({ active }) =>
		active ? styles.colors.lightGray : styles.colors.background};
	text-decoration: none;
	color: ${({ active }) =>
		active ? styles.colors.background : styles.colors.lightGray};
	font-weight: bold;
	border: 1.5px solid ${styles.colors.lightGray};
`

const Divider = styled.div`
	width: 100%;
	height: 1px;
	background-color: var(--tz-surface-raised, #1A202C);
	margin: 24px 0;
`

/**
 * 
 * @param {{
 *   posts:any[],
 *   problems?:any[],
 *   postsError:string,
 *   retry:()=>Promise<void>
 * }} props
 * @returns 
 */
export default function PostsAndProblems({
	posts = [],
	problems = [],
	postsError,
	page,
	setPage,
	retry
}) {

	if (postsError)
		return (
			<ErrorWrapper>
				<RetryButton onClick={retry} children={postsError} />
			</ErrorWrapper>
		)

	return (
		<Wrapper>
			{posts?.map(post => (
				<Post
					key={post.id}
					user={post.user}
					like_avatars={post.like_avatars}
					likes={post.likes}
					replies_count={post.replies_count}
					reply_glimpse={post.reply_glimpse}
					media={post.media}
					body={post.body}
					created_at={post.created_at}
				/>
			))}
			{/* {postsMeta?.total_pages > 1 && (
				<StyledPagination>
					{Array.from(Array(postsMeta.total_pages)).map((_, i) => (
						<StyledPaginationItem
							as='button'
							active={page === i + 1}
							onClick={() => setPage(i + 1)}
						>
							{i + 1}
						</StyledPaginationItem>
					))}
				</StyledPagination>
			)} */}
			{/* {problemsArr?.length && (
				<>
					<Divider />
					<Text.Heading type='h6' variant='bold'>
						Problems
					</Text.Heading>
					{problemsArr.map(problem => (
						<Post
							key={problem.id}
							user={problem.user}
							like_avatars={problem.like_avatars}
							likes={problem.likes}
							replies_count={problem.replies_count}
							reply_glimpse={problem.reply_glimpse}
							media={problem.media}
							body={problem.body}
							created_at={problem.created_at}
						/>
					))}
				</>
			)} */}
		</Wrapper>
	)
}
